// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\na {\n  text-decoration: none;\n}\ntr.v-data-table__selected {\n    /* color: primary; */\n    /* color: #81D4FA; */\n    font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
